<template>
  <sui-select :options="stageOptions" v-bind="$attrs" v-on="$listeners" />
</template>
<script>
export default {
  name: 'SuiCompetitionStageSelect',
  inject: {
    SuiForm: {
      default: null
    },
    SuiFormPage: {
      default: null
    }
  },
  props: {
    competitionId: {
      type: [Number, String],
      default: undefined
    }
  },
  data() {
    return {
      stageOptions: []
    }
  },
  computed: {
    _model() {
      return (this.SuiForm && this.SuiForm.model) || {}
    },
    _competitionId() {
      if (this.competitionId !== undefined) {
        return this.competitionId
      }
      return this._model.competitionId
    }
  },
  watch: {
    _competitionId: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => this.fetchOptions())
      }
    }
  },
  methods: {
    async fetchOptions() {
      if (!this._competitionId) {
        this.stageOptions = []
        return
      }

      let result = await this.$store.dispatch('MerchantSimbart/allActivityCompetitionStage', this._competitionId)
      // 获取数据
      this.stageOptions = result.map((it) => ({
        value: it.id,
        label: `${it.stageName}`
      }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/business/competition/SuiCompetitionStageSelect.vue